import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap'

//css
import './headerData.scss'


class HeaderData extends Component {
  constructor(props){
    super(props);
    this.state={
      whatsapp: false
    }
  }
  whatsapp(){
    this.setState({
      whatsapp: !this.state.whatsapp
    });
  }
  render() {
    return (
      <div className={"headerData"}>
        <Container>
          <Row className={"headerOption"}>
            <Col lg="5" md="5" sm="12" xs="12">
              <i className="fas fa-phone">
                <a href="" className={'phone'} > 313-280-7189</a>
              </i>
              <i className="fas fa-envelope-square" >
                <a href="mailto:jhonatancasas836@gmail.com" target="_blank" rel='noreferrer noopener' className={'email'} > jhonatancasas836@gmail.com</a>
              </i>
            </Col>
            <Col lg="2" md="2" sm="2" xs="2">
                <i onClick={()=> {this.whatsapp()}} className="fas fa-angle-double-down"></i>
                <a href='https://api.whatsapp.com/send?phone=(+57)3132807189&text=!Solicito%20Informacion!'>
                  <i className={(this.state.whatsapp? 'whatsappHidden': 'whatsappvisible') + " fab fa-whatsapp-square whatsapp"}></i>
                </a>
            </Col>
            <Col lg="5" md="5" sm="10" xs="10">
              <div className="Socials">
                <a href="https://www.facebook.com/portaprent" target="_blank" rel='noreferrer noopener ' >
                  <i className="fab fa-facebook-square facebook" ></i>
                </a>
                <a href="https://twitter.com/portaprent" target="_blank" rel='noreferrer noopener ' >
                  <i className="fab fa-twitter-square twitter" ></i>
                </a>
                <a href="" target="_blank">
                  <i className="fab fa-youtube-square youtube" ></i>
                </a>
                <a href="https://www.instagram.com/portaprent/" target="_blank" rel='noreferrer noopener ' >
                  <i className="fab fa-instagram instagram" ></i>
                </a>
                <a href="https://www.linkedin.com/company/portaprent/" target="_blank" rel='noreferrer noopener ' >
                  <i className="fab fa-linkedin linkedin" ></i>
                </a>
              </div>
            </Col>
            <Col>
              <div >
                
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}
export default HeaderData;



// WEBPACK FOOTER //
// ./src/Components/menu/header/HeaderData.jsx